export * from './string-template-outlet.directive';
export * from './string-template-outlet.module';
